import { convertArrayToObject } from "Services/Entity/helper";
import { getActionType } from "Store/Shared/Actions/Helpers";
import ACTIONS, { BLOCK_USER, FETCH_USER, FETCH_USERS, FETCH_USERS_DATASET, FETCH_USER_PERMISSIONS, UNBLOCK_USER } from "./ActionTypes";
import { initialUserState } from "./PropTypes";


export default function userReducer(state = initialUserState, action: any) {
    const { payload }  = action;
    switch (action.type) {
        case getActionType(ACTIONS.FETCH_USERS).REQUEST: {
            return {
                ...state,
                _isFetching: true,
                _forceFetch: false
            }
        }

        case getActionType(ACTIONS.UPDATE_USER).REQUEST: {
            return {
                ...state,
                _isPatching: true
            }
        }

        case getActionType(ACTIONS.FETCH_USERS).SUCCESS: {
            const { data } = payload;
            return {
                ...state,
                _isFetching: false,
                _forceFetch: true,
                ids: data.map(i => i?.user_id),
                entities: convertArrayToObject(data, 'user_id')
            }
        }

        case getActionType(ACTIONS.UPDATE_USER).SUCCESS: {
            const { data } = payload;

            return {
                ...state,
                _isPatching: false,
                entities: {
                    ...state.entities,
                    [data.user_id]: data
                }
            }
        }

        case FETCH_USERS_DATASET.REQUEST: {
            return {
                ...state,
                datasets: {
                    ...state.datasets,
                    _isFetching: true,
                    _forceFetch: false
                }
            }
        }

        case FETCH_USERS_DATASET.SUCCESS: {
            const { data } = payload;

            const selectableList = data
                .filter(i => i.email.includes('@growing-people.nl'))
                .map(i => i.user_id);

            return {
                ...state,
                datasets: {
                    ...state.datasets,
                    _isFetching: false,
                    ids: data.map(({ user_id }) => user_id),
                    entities: convertArrayToObject(data, 'user_id'),
                    selectableList
                }
            }
        }

        case BLOCK_USER.SUCCESS:
        case UNBLOCK_USER.SUCCESS: {
            const { data } = payload;

            return {
                ...state,
                entities: {
                    ...state.entities,
                    [data.user_id]: data
                }
            }
        }


        case FETCH_USERS.FAILURE:
        case BLOCK_USER.FAILURE:
        case UNBLOCK_USER.FAILURE:
        case FETCH_USER_PERMISSIONS.FAILURE:
        case FETCH_USER.FAILURE:
        default:
            return state;
    }
}